module.exports = __webpack_public_path__ + "static/media/online-teaching-img1.daa59651.jpg";